import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MUITable from "Components/UI/Tables/MUITable";
import useTableOptions from "Hooks/useTableOptions";

//MUI
import IconButton from "@mui/material/IconButton";
import LinkIcon from "@mui/icons-material/Link";
import { useAccountCharts } from "Context/AccountCharts";

const createTableRows = (accountCharts) => {
  return accountCharts?.map((i) => {
    return [
      i.Id,
      i.Title,
      i.Name,
      i.AccountNumber,
      i.Export,
      i.ExportedAccountName,
      i.ExportedAccountNumber,
      i.CreateTime,
    ];
  });
};

export default function AccountChartsTable() {
  const { isColDisplayed } = useTableOptions();
  const { accountCharts } = useAccountCharts();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const rows = createTableRows(accountCharts);
    setRows(rows);
  }, [accountCharts]);

  const columns = [
    {
      name: "",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <IconButton
              component={Link}
              to={`${rows[dataIndex][0]}`}
              aria-label="edit"
              size="small"
            >
              <LinkIcon sx={{ p: 0, m: 0 }} />
            </IconButton>
          );
        },
      },
    },
    {
      name: "Titel",
      options: {
        filter: false,
      },
    },
    {
      name: "Namn",
      options: {
        filter: false,
      },
    },
    {
      name: "Kontonummer",
      options: {
        filter: false,
      },
    },
    {
      name: "Export",
      options: {
        filter: false,
      },
    },
    {
      name: "Exporterat kontonamn",
      options: {
        filter: false,
      },
    },
    {
      name: "Exporterat kontonummer",
      options: {
        filter: false,
      },
    },
    {
      name: "Skapad",
      options: {
        filter: false,
        display: isColDisplayed("Skapad"),
      },
    },
  ];

  const options = {
    selectableRows: "none",
    selectableRowsHideCheckboxes: true,
    filterType: "dropdown",
    responsive: "standard",
    rowsPerPage: 30,
    rowsPerPageOptions: [10, 30, 100],
  };

  return <MUITable options={options} data={rows} columns={columns} />;
}
